/**
 * Returns `true` if given object is an item (workette, workset, etc.).
 *
 * @param obj
 */
export function isItem(obj) {
  return "context" in obj && "wtype" in obj["context"];
}
